<template>
  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Transactions</li>
      </ol>
    </div>
    <div class="transactions-table-wrp">
      <table class="table transactions-table">
        <thead>
        <th class="text-page">Name</th>
        <th class="text-page">Company Name</th>
        <th class="text-page">Transaction ID</th>
        <th class="text-page">Price</th>
        <th class="text-page">Actions</th>
        </thead>
        <tbody>
          <tr>
          <td class="text-page"></td>
          <td class="text-page"></td>
          <td class="text-page"> </td>
          <td class="text-page"></td>
          <td class="text-page">
            <button class="btn-link view-btn"></button>
            <button class="btn-link btn-delete"></button></td>
        </tr>
        <!-- <tr v-if="!partnerOffers.length">
          <td colspan="5" class="text-center text-page">No data found.</td>
        </tr> -->
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  components: {},
  data() {
    return {}
  },

  created() {

  },
  mounted() {

  },
  methods: {}
}
</script>
<style scoped>


</style>
